import React, { useEffect, useState } from 'react';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import S from './Support.module.css';

import { remote1, remote2, remote3, remote4, remote5, } from '../../assets/images/support/supportImages';
import { Link } from 'react-router-dom';

const RemotePage = () => {
  
  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  return (
    <div>
      <HeaderComponents pageKey="support" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="support" />
        </div>
        <div className='com-content-wrap mt-200'>
          <div style={{minHeight:'650px'}}>
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                원격지원
              </div>
              <div className={`${S.smallContentText} mt-20`}>
                -엠포플러스(주)에서 고객님의 불편을 덜어드리기 위하여 원격지원 서비스를 제공합니다.<br/><br/>
                - 원격지원 신청시 먼저 고객센터(1599-2320)를 통해 담당직원과 통화 한 후 신청해 주시기 바랍니다.<br/><br/>
                -원격지원 가능시간 : 평일 09:00-18:00<br/><br/>
                -아래 버튼을 클릭하여 원격지원 프로그램을 실행해 주시기 바랍니다.
              </div>
              <Link to={'http://emfoplus.co.kr/cscenter/remote'} className='text-line-none' target="_blank" >
                <div className={`${S.rmBtnDiv} mt-50`}>
                  원격지원 프로그램 실행
                </div>
              </Link>
            </div>
  
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={`${S.titleText} mb-50`}>
                원격지원 신청
              </div>
              <div className={S.rmBtnDivBox}>
                <div>
                  <Link to={'http://emfoplus.co.kr/cscenter/remote'} className='text-line-none' target="_blank" >
                    <div className={`${S.rmBtnDiv}`}>
                      원격지원 프로그램 실행
                    </div>
                  </Link>
                </div>
              </div>
              <div className={`${S.contentText} mt-50`}>
                <span className={S.bSmallContentText}>-엠포플러스(주) 고객센터 1599-2320 으로 전화합니다.</span><br />
                -담당 직원과 통화하여 원격지원을 요청합니다. <br/>
                -담당 직원의 안내에 따라 버튼을 클릭합니다.
              </div>
            </div>
  
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={`${S.titleText} mb-50`}>
                원격지원 프로그램 다운 및 실행
              </div>
              <img className={S.remoteImg} src={remote1} alt='remote' />
              <div className={`${S.contentText} mt-50`}>
                -실행 버튼을 클릭하면 인터넷 화면 하단 부분에 아래와 같이 다운로드 화면이 나옵니다.<br/>
                -메뉴에서 <span className={S.bSmallContentText}>실행 버튼을 클릭합니다.</span>
              </div>
            </div>
  
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={`${S.titleText} mb-50`}>
                윈도우 보안경고
              </div>
              <img className={S.remoteImg} src={remote2} alt='remote' />
              <div className={`${S.contentText} mt-50`}>
                -실행 버튼을 클릭하면 일부 컴퓨터에서 왼쪽 화면과 같은 보안 경고창이 나올 수 있습니다. <br/>
                -원격지원 프로그램이 실행하는것을 확인하는 창입니다. <br/>
                -<span className={S.bSmallContentText}>엑세스 허용 버튼을 클릭해 주세요.</span>
              </div>
            </div>
  
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={`${S.titleText} mb-50`}>
                원격지원 연결
              </div>
              <img className={S.remoteImg} src={remote3} alt='remote' />
              <div className={`${S.contentText} mt-50`}>
                -프로그램이 정상적으로 실행되면 왼쪽 화면의 창이 나옵니다.<br/>
                -Server 입력창에 2320을 입력 후 Login을 눌러주세요.
              </div>
              <img src={remote4} alt='remote' className={`${S.remoteImg} mt-50`}/>
              <div className={`${S.contentText} mt-50`}>
                -로그인이 정상적으로 실행되면 왼쪽 화면의 창이 나옵니다.<br/>
                -<span className={S.bSmallContentText}>상담원에게 왼쪽 화면의 4자리 숫자를 불러주세요.</span>
              </div>
              <img src={remote5} alt='remote' className={`${S.remoteImg} mt-50`}/>
              <div className={`${S.contentText} mt-50`}>
                -상담원이 연결하면 왼쪽 화면의 연결 수락창이 나옵니다.<br/>
                -예(Y) 버튼을 클릭하여 상담원의 연결에 수락해주세요.<br/>
                -화면이 깜빡이며 상담원과 원격이 연결됩니다.<br/>
                상담원의 안내에 따라 원격을 받으시면 됩니다.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemotePage;
